import { z } from 'zod'
import { requestEnvelopeV2 } from './client'
import { nullableArray } from './schemas'
// 固定站配对码（devices.pair.manage）——追加到 api/admin.ts 的部分
// 说明: 此文件内容将合并进 src/api/admin.ts 末尾

export const devicePairCodeSchema = z.object({
  code: z.string(),
  note: z.string(),
  status: z.enum(['active', 'used', 'revoked']),
  boundDeviceId: z.string().optional(),
  boundAt: z.number().optional(),
  createdBy: z.string().optional(),
  createdAt: z.number(),
})
export type DevicePairCode = z.infer<typeof devicePairCodeSchema>

export async function listPairCodes(): Promise<DevicePairCode[]> {
  return requestEnvelopeV2('/admin/device-pair-codes', nullableArray(devicePairCodeSchema))
}

export async function addPairCode(input: { code?: string; note: string }): Promise<{ code: string; note: string }> {
  return requestEnvelopeV2('/admin/device-pair-codes', z.object({ code: z.string(), note: z.string() }), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  })
}

export async function deletePairCode(code: string): Promise<void> {
  await requestEnvelopeV2(`/admin/device-pair-codes/${encodeURIComponent(code)}`, z.unknown(), {
    method: 'DELETE',
  })
}
